export interface IColumns {
  id: 'pair' | 'total' | 'revenue' | 'asset' | 'amount' | 'currency'
  label: string
  // eslint-disable-next-line
  format?: (value: any) => number
}

export interface IDataItem {
  pair?: string
  total?: number
  revenue?: number
  asset?: string
  amount?: string | number
  currency?: string
}

export interface IDataList {
  pairs?: IDataItem[]
  assets?: IDataItem[]
  total: number
  revenue: number
  // eslint-disable-next-line camelcase
  sub_total?: number
}
export interface IData {
  request: string
  columns: IColumns[]
}

export const revenueByAsset: IData = {
  request: 'trading/revenue-by-asset',
  columns: [
    {
      id: 'pair',
      label: 'PAIR',
    },
    {
      id: 'total',
      label: 'TOTAL VOLUME',
      // eslint-disable-next-line
      format: (value: any) => value?.toFixed(3),
    },
    {
      id: 'revenue',
      label: 'REVENUE',
      // eslint-disable-next-line
      format: (value: any) => value?.toFixed(3),
    },
  ],
}

export const totalAssetsStaked: IData = {
  request: 'staking/total-assets-staked',
  columns: [
    {
      id: 'asset',
      label: 'ASSETS',
      // eslint-disable-next-line
      format: (value: any) => (value ?? '').toUpperCase(),
    },
    {
      id: 'amount',
      label: 'STAKED',
      // eslint-disable-next-line
      format: (value: any) => (value ?? 0).toFixed(3),
    },
  ],
}

export const currentUnclaimedYields: IData = {
  request: 'staking/unclaimed-yields',
  columns: [
    {
      id: 'asset',
      label: 'ASSET',
      // eslint-disable-next-line
      format: (value: any) => (value ?? '').toUpperCase(),
    },
    {
      id: 'amount',
      label: 'YIELD',
      // eslint-disable-next-line
      format: (value: any) => (value ?? 0).toFixed(3),
    },
  ],
}

export const claimedYields: IData = {
  request: 'staking/claimed-yields',
  columns: [
    {
      id: 'asset',
      label: 'ASSET',
      // eslint-disable-next-line
      format: (value: any) => (value ?? '').toUpperCase(),
    },
    {
      id: 'amount',
      label: 'YIELD',
      // eslint-disable-next-line
      format: (value: any) => (value ?? 0).toFixed(3),
    },
  ],
}

/*
export const totalStaked: IData = {
  request: '',
  columns: [
    {
      id: 'type',
      label: 'TYPE',
    },
    {
      id: 'totalVolume',
      label: 'TOTAL VOLUME',
      // eslint-disable-next-line
      format: (value: any) => (value ?? 0).toFixed(3),
    },
    {
      id: 'revenue',
      label: 'REVENUE',
      // eslint-disable-next-line
      format: (value: any) => (value ?? 0).toFixed(3),
    },
  ],
}

export const staked: IData = {
  request: '',
  columns: [
    {
      id: 'type',
      label: 'TYPE',
    },
    {
      id: 'totalVolume',
      label: 'TOTAL VOLUME',
      // eslint-disable-next-line
      format: (value: any) => (value ?? 0).toFixed(3),
    },
    {
      id: 'revenue',
      label: 'REVENUE',
      // eslint-disable-next-line
      format: (value: any) => (value ?? 0).toFixed(3),
    },
  ],
}
*/
/*
export const stateData = {
  pairs: [
    {
      pair: 'BTC / EUR',
      total: 1000,
      assets: 'Asset 1',
      staked: 1000,
      asset: 'Asset 1',
      yield: 1000,
      type: 'Asset 1',
      totalVolume: 1000,
      revenue: 1000,
    },
    {
      pair: 'BTC / EUR',
      total: 5000,
      assets: 'Asset 2',
      staked: 1000,
      asset: 'Asset 2',
      yield: 1000,
      type: 'Asset 2',
      totalVolume: 1000,
      revenue: 1000,
    },
    {
      pair: 'BTC / ETH',
      total: 9000,
      assets: 'Asset 3',
      staked: 1000,
      asset: 'Asset 3',
      yield: 1000,
      type: 'Asset 3',
      totalVolume: 1000,
      revenue: 1000,
    },
    {
      pair: 'ETH / Basket 1',
      total: 12000,
      assets: 'Asset 4',
      staked: 1000,
      asset: 'Asset 4',
      yield: 1000,
      type: 'Asset 4',
      totalVolume: 1000,
      revenue: 1000,
    },
  ],
  totalOne: 4000,
  totalTwo: 4000,
}
*/
